module.exports = __webpack_public_path__ + "static/brand-songthai-1aed33ee076032b2a65f4d6e64a3a9c2.png";